var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-layout"},[_c('Sidebar'),_c('Navbar'),_c('div',{staticClass:"main__container",class:_vm.sideContainerClass},[_vm._t("default")],2),_c('BottomDock'),_c('Camera')],1)}
var staticRenderFns = []

export { render, staticRenderFns }